const shopify = require('./shopify')
const productsAds = require('./productsAds')

export { shopify, productsAds }
